import * as types from './currencyActionTypes';

const initialState = {
  currencyData: null,
  currencyList: [],
  createCurrencyData: null,
  createCurrencyError: null,
  updateCurrencyData: null,
  updateCurrencyError: null,
  deleteCurrencyData: null,
  deleteCurrencyError: null,
};

export const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CURRENCY_DATA:
      return {
        ...state,
        currencyData: action.payload || null,
        currencyList: action.payload?.CurrencyList || [],
      };
    case types.GET_CURRENCY_ERROR:
      return { ...state, currencyData: null, currencyList: [] };

    case types.CREATE_CURRENCY_DATA:
      return { ...state, createCurrencyData: action.payload, createCurrencyError: null };
    case types.CREATE_CURRENCY_ERROR:
      return { ...state, createCurrencyData: null, createCurrencyError: action.payload };

    case types.UPDATE_CURRENCY_DATA:
      return { ...state, updateCurrencyData: action.payload, updateCurrencyError: null };
    case types.UPDATE_CURRENCY_ERROR:
      return { ...state, updateCurrencyData: null, updateCurrencyError: action.payload };

    case types.DELETE_CURRENCY_DATA:
      return { ...state, deleteCurrencyData: action.payload, deleteCurrencyError: null };
    case types.DELETE_CURRENCY_ERROR:
      return { ...state, deleteCurrencyData: null, deleteCurrencyError: action.payload };

    default:
      return state;
  }
};
